<template>
  <div>
    <div class="tabel-title">
      <el-form label-width="80px" size="small" label-position="left">
        <el-form-item label="统计对象" class="mb-0">
          <el-radio-group v-model="status" @input="getData()" size="small">
            <el-radio :label="3">已报废</el-radio>
            <el-radio :label="1">未报废</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="组合条件" class="mb-0">
          <el-checkbox-group v-model="params">
            <el-checkbox
              label="model_number"
              value="model_number"
              key="model_number"
              disabled
              >型号</el-checkbox
            >
            <el-checkbox
              v-for="param in temp.custom_params"
              :label="param.label"
              :value="param.label"
              :key="param.key + param.label"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        class="export-btn"
        plain
        v-permission="
          temp.category == 1
            ? Auth.itemTemplateRepairAnalyzeExport
            : Auth.instrumentItemTemplateRepairAnalyzeExport
        "
        @click="handleExport()"
        :loading="downloading"
        >导出分析表</el-button
      >
    </div>
    <el-table
      :data="lists"
      size="small"
      border
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column
        label="组合条件"
        prop="model_number"
        align="center"
      ></el-table-column>
      <el-table-column
        label="维修次数"
        prop="repair_count"
        align="center"
      ></el-table-column>
      <el-table-column
        label="总使用时间"
        prop="total_man_hour"
        align="center"
      ></el-table-column>
      <el-table-column
        label="平均故障周期"
        prop="average"
        align="center"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { itemTemplateRepairAnalyzeList } from '@/service/getData'

export default {
  props: {
    temp: Object,
  },
  data() {
    return {
      list: [],
      params: ['model_number'],
      status: 3,
      downloading: false,
    }
  },
  created() {
    this.getData()
  },
  computed: {
    lists() {
      let data = []
      let _this = this
      let groups = this.groupBy(this.list, function (item) {
        let a = _this.params.map((key) => {
          return item[key]
        })
        return a
      })

      groups.map((items, index) => {
        let child = {
          id: 0,
          model_number: '',
          repair_count: 0,
          total_man_hour: 0,
          average: 0,
          children: [],
        }

        let children = items.map((c) => {
          let chl = this.clone(child)
          chl.id = c.id
          chl.model_number = c.code
          chl.repair_count = c.repair_count
          chl.total_man_hour = c.total_man_hour
          chl.children = []

          child.repair_count += c.repair_count
          child.total_man_hour += c.total_man_hour
          child.average = Math.round(child.total_man_hour / child.repair_count)
          return chl
        })

        children.map((item) => {
          item.average = child.average
        })

        child.id = index + 100000
        child.model_number = this.params.map((p) => {
          return items[0][p]
        })

        child.model_number = child.model_number.join('+')
        child.children = children
        data.push(child)
      })
      return data
    },
  },

  methods: {
    async getData() {
      let res = await itemTemplateRepairAnalyzeList({
        id: this.temp.id,
        status: this.status,
      })

      this.list = res.data.list.map((item) => {
        item.children = []
        item.hasChildren = false

        item.custom_params = this.copyCustomParam(
          this.temp.custom_params,
          item.custom_params
        )

        item.custom_params.map((param) => {
          item[param.label] = param.value || '空'
        })
        return item
      })

      this.list.sort(function (x, y) {
        return x.model_number - y.model_number
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          switch (j) {
            default:
              return v[j]
          }
        })
      )
    },
    formartList(list) {
      let data = []
      let merges = []

      let rowIndex = 0
      list.map((item) => {
        item.children.map((child) => {
          let row = this.list.filter((r) => r.id == child.id)[0]
          child.code = row.code
          child.model_number = row.model_number
          this.params.map((item, index) => {
            child[item] = row[item]
          })
          rowIndex++
          data.push(child)
        })
      })
      return { list: data, merges: merges }
    },
    handleExport() {
      this.downloading = true
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          '配件编号',
          '型号',
          '维修次数',
          '总使用时间',
          '平均寿命',
        ]

        const filterVal = [
          'code',
          'model_number',
          'repair_count',
          'total_man_hour',
          'average',
        ]

        this.params.map((item, index) => {
          if (item != 'model_number') {
            let p = this.temp.custom_params.filter((p) => p.label == item)[0]
            tHeader.splice(1 + index, 0, p.label)
            filterVal.splice(1 + index, 0, p.label)
          }
        })

        const d = this.formartList(this.lists)
        const data = this.formatJson(filterVal, d.list)

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.temp.name + '维修分析表',
          // autoWidth: this.autoWidth,
          // bookType: this.bookType,
        })
        this.downloading = false
      })
    },
  },
}
</script>

<style scoped>
.tabel-title {
  position: relative;
  padding-right: 100px;
}
.tabel-title .export-btn {
  position: absolute;
  right: 0;
  top: 0;
}
</style>